'use client';

import { ChakraProvider } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ThemeProvider } from 'next-themes';
import { getQueryClient } from '@/libs/react-query/queryClient';
import { system } from '@packages/wastic-shared';
import { tsrClient } from '@/libs/ts-rest/ts-client';

const Providers = ({ children }: PropsWithChildren) => {
	const queryClient = getQueryClient();

	return (
		<QueryClientProvider client={queryClient}>
			<tsrClient.ReactQueryProvider>
				<ChakraProvider value={system}>
					<ThemeProvider disableTransitionOnChange attribute={'class'} forcedTheme={'light'}>
						{children}
					</ThemeProvider>
				</ChakraProvider>
				<ReactQueryDevtools initialIsOpen={false} />
			</tsrClient.ReactQueryProvider>
		</QueryClientProvider>
	);
};

export default Providers;
